import React, { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Container } from "@material-ui/core";
import Header from "../components/Header";
import SideMenu from "../components/SideMenu";
import { isEmbedMode } from "../constants/embedMode";

const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: "100vh",
    width: "100%",
    overflow: "hidden",
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
    padding: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
    },
    transition: theme.transitions.create(["margin-left"], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard,
    }),
    marginLeft: 0,
    width: "100%",
  },
  // Versão compacta para páginas de jobs
  contentCompact: {
    flexGrow: 1,
    height: "100vh",
    overflow: "hidden", // Alterado para hidden - o scroll fica no JobManager
    padding: 0,
    display: "flex",
    flexDirection: "column",
    transition: theme.transitions.create(["margin-left"], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard,
    }),
    marginLeft: 0,
    width: "100%",
  },
  contentWithMenu: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: drawerWidth,
    },
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    transition: theme.transitions.create("max-width", {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard,
    }),
  },
  // Container compacto para páginas de jobs
  containerCompact: {
    padding: 0,
    margin: 0,
    maxWidth: "none",
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    minHeight: 0, // Importante para que o flex funcione corretamente
  },
}));

const MainLayout = ({
  children,
  isAuthenticated,
  setIsAuthenticated,
  compact = false,
  embedMode: embedModeProp = false,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const classes = useStyles();
  const embedMode = isEmbedMode();

  const handleToggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Determina se deve usar o layout compacto baseado na prop
  const isCompactLayout = compact || embedMode;

  return (
    <div className={classes.root}>
      {!embedMode && (
        <Header
          isAuthenticated={isAuthenticated}
          setIsAuthenticated={setIsAuthenticated}
          onMenuClick={handleToggleMenu}
          menuOpen={menuOpen}
        />
      )}

      {isAuthenticated && !embedMode && (
        <SideMenu open={menuOpen} setOpen={setMenuOpen} />
      )}

      <main
        className={`${
          isCompactLayout ? classes.contentCompact : classes.content
        } ${menuOpen && !embedMode ? classes.contentWithMenu : ""}`}
      >
        {!embedMode && <div className={classes.appBarSpacer} />}
        {isCompactLayout ? (
          // Layout compacto - sem Container
          <div className={classes.containerCompact}>{children}</div>
        ) : (
          // Layout normal
          <Container
            maxWidth={false}
            className={classes.container}
            style={{
              maxWidth: menuOpen ? "calc(100% - 48px)" : "calc(100% - 48px)",
            }}
          >
            {children}
          </Container>
        )}
      </main>
    </div>
  );
};

export default MainLayout;
